import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class CartService {

  private isBrowser: boolean;

  isAr: boolean = false;
  public cartItems: any[] = [];

  private cartCount = new BehaviorSubject<number>(0);
  cartCount$ = this.cartCount.asObservable();

  private thisUserId: string = 'guest';

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    if (this.isBrowser) {
      const lang = localStorage.getItem('language');
      this.isAr = lang === 'ar';

      this.thisUserId = localStorage.getItem('userId') || 'guest';

      this.cartItems = this.getSavedCart();
      this.cartCount.next(this.getSavedCartCount());
    }
  }

  // ✅ تحميل الكارت
  private getSavedCart(): any[] {
    if (!this.isBrowser) return [];
    const saved = localStorage.getItem('cart');
    return saved ? JSON.parse(saved) : [];
  }

  // ✅ حساب العدد
  private getSavedCartCount(): number {
    return this.cartItems.reduce((sum, item) => sum + item.quantity, 0);
  }
  addBundleToCart(bundle: any) {

    const index = this.cartItems.findIndex(
      item => item.type === "bundle" &&
        item.product.id === bundle.id &&
        item.userId === this.thisUserId
    );

    // Bundle quantity الحالية في الكارت
    const currentBundleQty = index !== -1 ? this.cartItems[index].quantity : 0;

    // Bundle quantity الجديدة لو ضغط Add
    const newBundleQty = currentBundleQty + 1;

    // ✅ Check Stock Availability
    const outOfStockItem = bundle.items.find((sub: any) => {

      const stockAvailable = parseInt(sub.stock.quantity); // كمية المخزون
      const requiredQty = sub.quantity * newBundleQty;     // الكمية المطلوبة

      return requiredQty > stockAvailable;
    });

    // ❌ لو في عنصر مش مكفي
    if (outOfStockItem) {

      Swal.fire({
        icon: "error",
        title: this.isAr
          ? `للأسف الكمية غير متاحة للمنتج: ${outOfStockItem.stock.name_ar}`
          : `Not enough stock for: ${outOfStockItem.stock.name_en}`,
        text: this.isAr
          ? `المتاح: ${outOfStockItem.stock.quantity}`
          : `Available: ${outOfStockItem.stock.quantity}`,
        timer: 3500,
        showConfirmButton: false
      });

      return;
    }

    // ✅ لو كله تمام نزود Bundle
    if (index !== -1) {
      this.cartItems[index].quantity += 1;
    } else {
      this.cartItems.push({
        userId: this.thisUserId,
        type: "bundle",
        product: bundle,
        quantity: 1,
        items: bundle.items
      });
    }

    this.saveCart();
  }
  getBundleQuantity(bundleId: number): number {

    const item = this.cartItems.find(
      x => x.type === "bundle" &&
        x.product.id === bundleId &&
        x.userId === this.thisUserId
    );

    return item ? item.quantity : 0;
  }

  removeBundleFromCart(bundle: any) {

    const index = this.cartItems.findIndex(
      item => item.type === "bundle" &&
        item.product.id === bundle.id &&
        item.userId === this.thisUserId
    );

    if (index !== -1) {

      if (this.cartItems[index].quantity > 1) {
        this.cartItems[index].quantity -= 1;
      } else {
        this.cartItems.splice(index, 1);
      }

      this.saveCart();
    }
  }

  // 🛒 إضافة منتج
  addToCart(product: any) {

    const maxQty = parseInt(product.quantity);

    const index = this.cartItems.findIndex(
      item => item.product.id === product.id &&
        item.userId === this.thisUserId
    );

    if (index !== -1) {

      const currentQty = this.cartItems[index].quantity;

      if (currentQty < maxQty) {
        this.cartItems[index].quantity += 1;
      } else {
        this.showError(product);
        return;
      }

    } else {

      if (maxQty > 0) {
        this.cartItems.push({
          userId: this.thisUserId,
          product,
          quantity: 1,
        });
      } else {
        this.showError(product);
        return;
      }

    }

    this.saveCart();
  }


  // 🗑️ إزالة منتج
  removeFromCart(product: any) {
    const index = this.cartItems.findIndex(
      item => item.product.id === product.id && item.userId === this.thisUserId
    );

    if (index !== -1) {
      if (this.cartItems[index].quantity > 1) {
        this.cartItems[index].quantity -= 1;
      } else {
        this.cartItems.splice(index, 1);
      }
      this.saveCart();
    }
  }

  // 💾 حفظ الكارت
  private saveCart() {
    if (!this.isBrowser) return;

    if (this.cartItems.length > 0) {
      localStorage.setItem('cart', JSON.stringify(this.cartItems));
    } else {
      localStorage.removeItem('cart');
    }

    const count = this.getSavedCartCount();
    localStorage.setItem('cartCount', count.toString());
    this.cartCount.next(count);
  }

  // 🔍 رجوع الكارت
  getCartItems() {
    return this.cartItems;
  }

  // 🧹 تنظيف
  clearCart() {
    this.cartItems = [];
    this.cartCount.next(0);

    if (!this.isBrowser) return;

    [
      'cart',
      'cartTotal',
      'deliveryFees',
      'cartDiscount',
      'cartCount',
      'shipping',
    ].forEach(key => localStorage.removeItem(key));
  }

  // 📦 كمية منتج
  getProductQuantity(productId: number): number {
    const item = this.cartItems.find(
      item => item.product.id === productId && item.userId === this.thisUserId
    );
    return item ? item.quantity : 0;
  }

  // ⚠️ Alert
  private showError(product: any) {
    if (!this.isBrowser) return;

    Swal.fire({
      icon: 'error',
      title: this.isAr
        ? `للأسف ${product.name_ar} مش متاح منه كمية أكتر`
        : `There is no more quantity of ${product.name_en}`,
      showConfirmButton: false,
      timer: 3000,
    });
  }
}
